export const convertTimeToMinutes = (dateTimeString?: string): number => {
  if (!dateTimeString) return 0;

  // Create a Date object from the provided string
  const date = new Date(dateTimeString);

  // Get the hours, minutes, and seconds
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Convert hours to minutes and add them to the actual minutes
  const totalMinutes = hours * 60 + minutes;

  return totalMinutes;
}
